/**
 * Générateur — Automatisme : donner une médiane pour une série comportant un
 * petit nombre de valeurs.
 * Attendu ID : 1247 | Niveau : 3ème | Domaine : Statistiques
 * Rubrique : AUTOMATISME (programme 2025, cycle 4 page 17, ligne 1253).
 *
 * Les clés med_* de gen_1246 (un fichier « stats », trois jeux de clés,
 * modèle 1101/1105) : les trois indicateurs se calculent sur la même série
 * brute et se confondent chez l'élève. Ici seules les clés med_* sont
 * servies ; les payloads portent déjà l'attendu 1247.
 */
import { genererParmi, CATEGORIES_MEDIANE } from './gen_1246';

export const CATEGORIES = CATEGORIES_MEDIANE;
const CLES = CATEGORIES_MEDIANE.flatMap((c) => c.formatsList.map(({ key }) => key));
export const generate = (typeExercice) => genererParmi(CLES, typeExercice);
